import createLucideIcon from '../createLucideIcon';

const Check = createLucideIcon('CheckIcon', [
  ['polyline', { points: '20 6 9 17 4 12', key: '10jjfj' }],
]);

export default Check;
